 const config = {
  bsn: [
    {"val": "290888", "showmsg": "AP31前副"},
    {"val": "299050", "showmsg": "AP31MCE前副"},
    {"val": "291584", "showmsg": "ZS11MCE前副"},
    {"val": "299437", "showmsg": "ZS11前副（国外版）"},
    {"val": "293919", "showmsg": "ZS12HEV前副"},
    {"val": "298657", "showmsg": "ZS12HEV前副（漆膜加厚件）"},
    {"val": "2A6859", "showmsg": "ZS11后桥"},
    {"val": "2A6666", "showmsg": "ZS11EV后桥"},
    {"val": "2A1903", "showmsg": "ZS11EMCE后桥"}
  ]
};


export function listConfig(key) {
  return config[key];
}



// WEBPACK FOOTER //
// ./src/config/bsn.js